import { inject, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject } from 'rxjs';

import { ConfirmModalComponent } from '../modals/confirm-modal/confirm-modal.component';
import { TypedConfirmModalComponent } from '../modals/typed-confirm-modal/typed-confirm-modal.component';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  private modalService: NgbModal;

  constructor() {
    this.modalService = inject(NgbModal);
  }

  public showConfirm(title = '', text = ''): Observable<boolean> {
    const resultSubject = new Subject<boolean>();

    const modal = this.modalService.open(ConfirmModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static',
      centered: true,
      size: 'lg',
      windowClass: 'dark-modal ltr',
    });

    (modal.componentInstance as ConfirmModalComponent).title = title;
    (modal.componentInstance as ConfirmModalComponent).text = text;

    // eslint-disable-next-line promise/catch-or-return
    modal.result.then(
      (result: boolean) => {
        // eslint-disable-next-line promise/always-return
        if (result) {
          resultSubject.next(true);
        } else {
          resultSubject.next(false);
        }

        resultSubject.complete();
      },
      () => {
        resultSubject.next(false);
        resultSubject.complete();
      }
    );
    return resultSubject;
  }

  public showTypedConfirm(title = '', text = '', requiredText = ''): Observable<boolean> {
    const resultSubject = new Subject<boolean>();

    const modal = this.modalService.open(TypedConfirmModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static',
      centered: true,
      size: 'lg',
      windowClass: 'dark-modal ltr',
    });

    (modal.componentInstance as TypedConfirmModalComponent).setContent(title, text, requiredText);

    // eslint-disable-next-line promise/catch-or-return
    modal.result.then(
      (result: boolean) => {
        // eslint-disable-next-line promise/always-return
        if (result) {
          resultSubject.next(true);
        } else {
          resultSubject.next(false);
        }

        resultSubject.complete();
      },
      () => {
        resultSubject.next(false);
        resultSubject.complete();
      }
    );
    return resultSubject;
  }
}
